import dashboardNavbarConst from '@/consts/dashboardNavbar.const.js';

const valuationsRoutes = [
    { 
      path: '/valuations',
      name: 'valuations',
      component: () => import(/* webpackChunkName: "valuations" */ '@/pages/globalEndToEnd/valuations/valuations.vue'),
      props: true,
      meta: {
        id: dashboardNavbarConst.VALUATIONS,
      },
    },
  ];
  
  export default valuationsRoutes;
  